import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { LineaDeAyuda } from '../ui/linea-de-ayuda';

/**
 * La ayuda de la pestaña Estrategias (maqueta: «ⓘ Una estrategia elige
 * productos… ¿Cómo funcionan?»). Cerrada por omisión: la línea sola. Abierta,
 * los tres pasos, en el mismo recuadro que la ayuda de Reglas.
 */
export function AyudaEstrategias() {
  const [abierta, setAbierta] = useState(false);
  return (
    <div className="space-y-3">
      <LineaDeAyuda
        accion={
          <Button
            variant="link"
            size="sm"
            className="h-auto p-0 font-semibold"
            aria-expanded={abierta}
            onClick={() => setAbierta((v) => !v)}
          >
            {abierta ? 'Ocultar' : '¿Cómo funcionan?'}
          </Button>
        }
      >
        Una <strong className="font-semibold text-foreground">estrategia</strong> elige productos,
        calcula su precio con un método y te lo propone para que decidas.
      </LineaDeAyuda>
      {abierta && (
        <section
          aria-label="Cómo funcionan las estrategias"
          className="grid gap-4 rounded-tarjeta border border-dashed border-border bg-card px-5 py-4 text-sm leading-relaxed text-foreground/80 md:grid-cols-3"
        >
          <p>
            <strong className="font-semibold text-foreground">Elige productos:</strong> todo el
            catálogo, categorías, marcas o algunos elegidos a mano.
          </p>
          <p>
            <strong className="font-semibold text-foreground">
              Calcula su precio con un método:
            </strong>{' '}
            igualar al más barato, quedar un porcentaje por debajo, apuntar a un margen… Corre según
            su calendario, cuando llegan precios nuevos o cuando la pedís.
          </p>
          <p>
            <strong className="font-semibold text-foreground">Te lo propone:</strong> el precio
            respeta tus reglas y espera tu sí en Revisar precios, salvo que le hayas dado permiso de
            aplicarlo sola.
          </p>
        </section>
      )}
    </div>
  );
}
